import * as types from './mutation-types'
import {default as auth, namespace as authNamespace} from './modules/auth'
import {default as pages, namespace as pageNamespace} from './modules/pages'
import {default as giftcard, namespace as giftcardNamespace} from './modules/giftcard'
import {default as race, namespace as raceNamespace} from './modules/race'
import {default as timer, namespace as timerNamespace} from './modules/timer'
import {default as tickets, namespace as ticketsNamespace} from './modules/tickets'
import {default as events, namespace as eventsNamespace} from './modules/event-reservation'
import createPersistedState from 'vuex-persistedstate'
import createMultiTabState from 'vuex-multi-tab-state'

const location = window.addiesaas.location || {}
const locationId = location.id || ''
const locationIdKey = locationId ? `/${locationId}`: ''

// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
const namespace = 'RacewayBooking'

const modules = {
  [authNamespace]: auth,
  [pageNamespace]: pages,
  [giftcardNamespace]: giftcard,
  [raceNamespace]: race,
  [timerNamespace]: timer,
  [ticketsNamespace]: tickets,
  [eventsNamespace]: events,
}

// state
const state = {

}
const helpers = {}

// mutations
const mutations = {}

const actions = {}

// getters
const getters = {

}

// plugins
const plugins = [
  createPersistedState({
    paths: [
      `${namespace}.${authNamespace}`,
      // `${namespace}.${raceNamespace}.editItem`,
      // `${namespace}.${raceNamespace}.cartItems`,
      // `${namespace}.${eventsNamespace}.editItem`,
      // `${namespace}.${eventsNamespace}.cartItems`,
      // `${namespace}.${giftcardNamespace}.editItem`,
      // `${namespace}.${giftcardNamespace}.cartItems`,
      `${namespace}.${pageNamespace}.postLoginPage`,
      `${namespace}.${pageNamespace}.postLoginSection`,
      `${namespace}.${pageNamespace}.isPreCheckoutRegistration`,
      `${namespace}.${pageNamespace}.checkoutState`,
      `${namespace}.${pageNamespace}.billingTotal`,
      `${namespace}.${pageNamespace}.billingGuestEmail`,
      `${namespace}.${pageNamespace}.expirationTimeBillingError`,
      `${namespace}.${timerNamespace}`
    ],
    key: namespace + locationIdKey,
  }),
  createMultiTabState({
    statesPaths: [
      `${namespace}.${timerNamespace}`,
    ],
    key: 'shop-orders-timers-multi-tab' + locationIdKey,
  })
]

export {namespaced, namespace, state, mutations, actions, getters, plugins, modules}
